import axiosInstance from "../AxiosInstance";

export const getCameras = async (projectId, deviceUserId) => {
    const params = {};
    if (projectId) params.project_id = projectId;
    if (deviceUserId) params.device_user_id = deviceUserId;
    const response = await axiosInstance.get('ip_camera/', { params });
    return response.data.results || response.data;
};

export const createCamera = async (data) => {
    const response = await axiosInstance.post('ip_camera/', data);
    return response.data;
};

export const updateCamera = async (id, data) => {
    const response = await axiosInstance.put(`ip_camera/${id}/`, data);
    return response.data;
};

export const deleteCamera = async (id) => {
    await axiosInstance.delete(`ip_camera/${id}/`);
};

export const discoverOnvif = async (host, port, username, password, rtsp_port) => {
    const response = await axiosInstance.post('ip_camera/discover_onvif/', {
        host, port, username, password, ...(rtsp_port ? { rtsp_port } : {})
    });
    return response.data;
};

export const diagnoseCamera = async (host, port, username, password) => {
    const response = await axiosInstance.post('ip_camera/diagnose/', {
        host, port, username, password
    });
    return response.data;
};

export const checkPtz = async (cameraId) => {
    const response = await axiosInstance.post(`ip_camera/${cameraId}/check_ptz/`);
    return response.data;
};

export const sendPtzCommand = async (cameraId, action, pan = 0, tilt = 0, zoom = 0) => {
    const response = await axiosInstance.post(`ip_camera/${cameraId}/ptz_command/`, {
        action, pan, tilt, zoom
    });
    return response.data;
};
